import { CreateMultiLegShippingEstimateByFuelResponse } from '@lune-climate/lune'
import { SuccessResponseWithMeta } from '@lune-climate/lune/esm/core/SuccessResponse'
import { MultiLegShippingByFuelEstimateResult } from '@lune-fe/lune-components-lib'
import { useIsMobile } from '@lune-fe/lune-ui-lib'
import { FC, RefObject, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { asSuccessResponseWithMeta } from 'endpoints/util'
import useIsTestMode from 'hooks/useIsTestMode'
import { useLuneClient } from 'hooks/useLuneClient'
import useTitle from 'hooks/useTitle'
import useToken from 'hooks/useToken'
import { getTestApiKey } from 'utils'
import { ResultsWrapper } from 'views/CalculateEmissions'

const MultiLegShippingByFuelEstimateResults: FC<{ scrollRef: RefObject<HTMLDivElement> }> = ({
    scrollRef,
}) => {
    useTitle('Multi-leg Logistics By Fuel Emissions Results')
    const { id } = useParams<{ id: string }>()
    const [estimate, setEstimate] =
        useState<SuccessResponseWithMeta<CreateMultiLegShippingEstimateByFuelResponse>>()
    const luneClient = useLuneClient()
    const isTestMode = useIsTestMode()
    const testApiKey = getTestApiKey()
    const { isMobile } = useIsMobile()
    const { token } = useToken()

    useEffect(() => {
        if (id) {
            luneClient.getMultiLegShippingEstimateByFuel(id).then((res) => {
                if (res.isOk()) {
                    const e = asSuccessResponseWithMeta(res.value)
                    setEstimate(e)
                }
            })
        }
    }, [id, luneClient])

    return (
        <>
            {estimate && (
                <ResultsWrapper
                    scrollRef={scrollRef}
                    calculatedAmount={estimate.mass.amount}
                    estimateId={id}
                    token={token ?? undefined}
                >
                    <MultiLegShippingByFuelEstimateResult
                        estimate={estimate}
                        enableEmissionFactorLink={true}
                        requestAndResponseSnippets={{ isTestMode, testApiKey }}
                        isMobile={isMobile}
                    />
                </ResultsWrapper>
            )}
        </>
    )
}

export default MultiLegShippingByFuelEstimateResults
